import client from './_client'
import store from '../../store'

const API_TOKEN = `${process.env.VUE_APP_API_TOKEN}`

export default {
  getUserDetails(accountId, locationId) {
    return client({
      method: 'GET',
      url: `api/v1/account/permissions?account_id=${accountId}&location_id=${locationId}`,
      headers: {
        'auth-token': store.getters['auth/authToken']
      }
    })
  },

  getMyPermissions() {
    return client({
      method: 'GET',
      url: `api/v1/integrators/users/permissions?app_identifier=io.unoapp.forms2`,
      headers: {
        'api-token': API_TOKEN,
        'auth-token': store.getters['auth/authToken']
      }
    })
  },

  // getDashboardStats(accountId, formRefId) {
  //   return client({
  //     method: 'GET',
  //     url: `api/v1/dashboard/summary/${formRefId}?account_id=${accountId}`,
  //     headers: {
  //       'auth-token': store.getters['auth/authToken']
  //     }
  //   })
  // },

  // getAccountsByLocation(locationId) {
  //   return client({
  //     method: 'GET',
  //     url: `api/v1/account/location/${locationId}`,
  //     headers: {
  //       'auth-token': store.getters['auth/authToken']
  //     }
  //   })
  // },

  createNewSubmission(formId) {
    return client({
      method: 'POST',
      url: `/v2/submission/forms/${formId}`,
      headers: {
        'client-token': store.getters['user/clientToken'],
        'auth-token': store.getters['auth/authToken']
      }
    })
  },

  submitSingleAnswer(data) {
    return client({
      method: 'POST',
      url: 'api/v1/account/submit/answer',
      headers: {
        'submission-token': store.getters['form/selectedSubmissionToken'],
        'client-token': store.getters['user/clientToken'],
        'auth-token': store.getters['auth/authToken']
      },
      data
    })
  },

  updateAnswer(data) {
    return client({
      method: 'PATCH',
      url: 'api/v1/account/submit/answer',
      headers: {
        'submission-token': store.getters['form/selectedSubmissionToken'],
        'client-token': store.getters['user/clientToken'],
        'auth-token': store.getters['auth/authToken']
      },
      data
    })
  },

  submitMultipleAnswers(data) {
    return client({
      method: 'POST',
      url: 'api/v1/account/submit/answers',
      headers: {
        'submission-token': store.getters['form/selectedSubmissionToken'],
        'client-token': store.getters['user/clientToken'],
        'auth-token': store.getters['auth/authToken']
      },
      data
    })
  },

  getSubmissionStats() {
    return client({
      method: 'GET',
      url: `api/v1/submission/status?submission_token=${store.getters['form/selectedSubmissionToken']}`,
      headers: {
        'submission-token': store.getters['form/selectedSubmissionToken'],
        'client-token': store.getters['user/clientToken'],
        'auth-token': store.getters['auth/authToken']
      }
    })
  },
  submitSubmission(data) {
    return client({
      method: 'POST',
      url: 'api/v1/account/submit/form',
      headers: {
        'submission-token': store.getters['form/selectedSubmissionToken'],
        'client-token': store.getters['user/clientToken'],
        'auth-token': store.getters['auth/authToken']
      },
      data
    })
  },

  approveSubmission(formId, data) {
    return client({
      method: 'POST',
      url: `api/v1/respondents/forms/${formId}/approval`,
      headers: {
        'submission-token': store.getters['form/selectedSubmissionToken'],
        'client-token': store.getters['user/clientToken'],
        'auth-token': store.getters['auth/authToken']
      },
      data
    })
  },

  updateSubmissionholdStatus(data) {
    return client({
      method: 'POST',
      url: 'api/v1/submission/onhold',
      headers: {
        'submission-token': store.getters['form/selectedSubmissionToken'],
        'client-token': store.getters['user/clientToken'],
        'auth-token': store.getters['auth/authToken']
      },
      data
    })
  }
}
